import { useContext } from "react";
import { WizardStateContext } from "./WizardProvider";

export function useWizardState() {
  const state = useContext(WizardStateContext);

  return state;
}